var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilewallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57144 6.70001H10.5286V7.65716H9.57144V6.70001Z",
    fill: "#3B4F7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4429 2.39286H0.957143V0.957143H11.4857V0H0.957143C0.703293 0 0.45984 0.100841 0.280341 0.280341C0.100841 0.45984 0 0.703293 0 0.957143V11.0071C0 11.261 0.100841 11.5044 0.280341 11.6839C0.45984 11.8634 0.703293 11.9643 0.957143 11.9643H12.4429C12.6967 11.9643 12.9402 11.8634 13.1197 11.6839C13.2992 11.5044 13.4 11.261 13.4 11.0071V3.35C13.4 3.09615 13.2992 2.8527 13.1197 2.6732C12.9402 2.4937 12.6967 2.39286 12.4429 2.39286ZM0.957143 11.0071V3.35H12.4429V4.78571H8.61429C8.36044 4.78571 8.11698 4.88656 7.93748 5.06605C7.75798 5.24555 7.65714 5.48901 7.65714 5.74286V8.61428C7.65714 8.86814 7.75798 9.11159 7.93748 9.29109C8.11698 9.47059 8.36044 9.57143 8.61429 9.57143H12.4429V11.0071H0.957143ZM12.4429 5.74286V8.61428H8.61429V5.74286H12.4429Z",
    fill: "#3B4F7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilewallet);
export default __webpack_public_path__ + "static/media/mobilewallet.e6a567a62e5f1437baaf5f8386c89b54.svg";
export { ForwardRef as ReactComponent };